// Behaviour for the page layouts: fleet filter, quote panel, process steps journey, offers.

module.exports = function () {

    let module = {};

    // Transmission tabs (or dropdown on phones) on the fleet grid
    module.initFleetFilter = function () {
        $('.fleet').each(function () {
            let $fleet = $(this);
            let $count = $fleet.find('[data-fleet-count]');
            let noun = $count.data('noun') || 'vehicle';

            let apply = function (value) {
                $fleet.find('[data-fleet-filter]').each(function () {
                    let on = $(this).data('fleet-filter') === value;
                    $(this).toggleClass('active', on).attr('aria-pressed', on ? 'true' : 'false');
                });
                $fleet.find('[data-fleet-filter-select]').val(value);

                // data-transmission holds space-separated tags, e.g. "manual automatic"
                let $items = $fleet.find('.fleet-grid [data-transmission]');
                $items.each(function () {
                    let tags = String($(this).data('transmission') || '').split(' ');
                    $(this).toggleClass('is-hidden', value !== 'all' && tags.indexOf(value) === -1);
                });

                let shown = $items.not('.is-hidden').length;
                $count.text(shown + ' ' + noun + ' option' + (shown === 1 ? '' : 's'));
            };

            $fleet.on('click', '[data-fleet-filter]', function () {
                apply($(this).data('fleet-filter'));
            });

            $fleet.on('change', '[data-fleet-filter-select]', function () {
                apply($(this).val());
            });
        });
    };

    // "Request a quote" on the vehicle page opens the enquiry panel. Arriving with #quote opens it too.
    module.initQuotePanel = function () {
        let $panel = $('#quote');
        if (!$panel.length)
            return;

        let reveal = function () {
            // Show the "Request a quote" button and the vehicle summary above the form
            // (html has scroll-behavior: smooth, which fights jQuery's animate, so use the native scroll)
            window.scrollTo({top: $('[data-quote-toggle]').offset().top - 140, behavior: 'smooth'});

            let first = $panel.find('input:visible').get(0);
            if (first)
                setTimeout(function () { first.focus({preventScroll: true}); }, 450);
        };

        let open = function () {
            $('[data-quote-toggle]').attr('aria-expanded', 'true');

            if ($panel.hasClass('show'))
                return reveal();

            $panel.one('shown.bs.collapse', reveal).collapse('show');
        };

        $('[data-quote-toggle]').on('click', function (e) {
            e.preventDefault();
            open();
        });

        // Re-open after a failed submit, or when linked from a fleet card
        if (window.location.hash === '#quote' || $panel.find('.alert-danger, .invalid-feedback').length) {
            if ('scrollRestoration' in history)
                history.scrollRestoration = 'manual';
            // Wait a beat after load: the gallery slider and WOW reset the scroll while they set up
            let openSoon = function () { setTimeout(open, 350); };
            document.readyState === 'complete' ? openSoon() : $(window).on('load', openSoon);
        }
    };

    // "Go up" button in the footer
    module.initBackToTop = function () {
        $('.back-to-top').on('click', function () {
            let reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({top: 0, behavior: reduced ? 'auto' : 'smooth'});
        });
    };

    // Process steps "journey": a winding road between the step bubbles. The amber line follows
    // the scroll, a van rides its tip, and each bubble pops when the line reaches it.
    module.initJourney = function () {
        $('[data-journey]').each(function () {
            let journey = this;
            let svg = journey.querySelector('.journey-road');
            let track = svg.querySelector('.journey-road-track');
            let progress = svg.querySelector('.journey-road-progress');
            let van = journey.querySelector('.journey-van');
            let $steps = $(journey).find('.journey-step');
            let $stops = $(journey).find('[data-journey-stop]');
            let length = 0, samples = [], stopYs = [];

            // Points are the centres of each bubble (and the finish), relative to the journey
            let centre = function (el) {
                let box = el.getBoundingClientRect(), outer = journey.getBoundingClientRect();
                return {x: box.left - outer.left + box.width / 2, y: box.top - outer.top + box.height / 2, top: box.top - outer.top, bottom: box.bottom - outer.top};
            };

            let draw = function () {
                let width = journey.offsetWidth, height = journey.offsetHeight;
                svg.setAttribute('width', width);
                svg.setAttribute('height', height);
                svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);

                // A stop marked data-journey-stop="top" (the finish) is met at its top edge, not its centre
                let points = $stops.map(function () {
                    let c = centre(this);
                    return this.getAttribute('data-journey-stop') === 'top' ? $.extend(c, {y: c.top}) : c;
                }).get();
                if (points.length < 2)
                    return;

                let d = 'M' + points[0].x + ' ' + points[0].y;
                for (let i = 1; i < points.length; i++) {
                    let a = points[i - 1], b = points[i], dy = b.y - a.y;

                    if (Math.abs(b.x - a.x) < 12) {
                        // Same column (phones): a gentle wiggle
                        let w = (i % 2 ? 1 : -1) * Math.min(28, width * .08);
                        d += ' C' + (a.x + w) + ' ' + (a.y + dy * .4) + ' ' + (b.x - w) + ' ' + (b.y - dy * .4) + ' ' + b.x + ' ' + b.y;
                    } else {
                        // Swap sides: drop down, swoop across the gap between the steps, drop in
                        let gap = (centre($steps.get(i - 1) || $stops.get(i - 1)).bottom + b.top) / 2;
                        let r = Math.max(30, Math.min(90, (b.top - a.y) / 2));
                        d += ' L' + a.x + ' ' + Math.max(a.y, gap - r);
                        d += ' C' + a.x + ' ' + (gap + r * .35) + ' ' + b.x + ' ' + (gap - r * .35) + ' ' + b.x + ' ' + Math.min(b.y, gap + r);
                        d += ' L' + b.x + ' ' + b.y;
                    }
                }

                track.setAttribute('d', d);
                progress.setAttribute('d', d);
                length = progress.getTotalLength();
                progress.style.strokeDasharray = length + ' ' + length;

                samples = [];
                for (let l = 0; l < length; l += 6)
                    samples.push({l: l, p: progress.getPointAtLength(l)});
                // Always end on the very end of the line, or the finish badge never lights up
                samples.push({l: length, p: progress.getPointAtLength(length)});
                stopYs = points.map(function (p) { return p.y; });

                journey.classList.add('is-live');
                update();
            };

            let update = function () {
                if (!samples.length)
                    return;

                // The tip of the line sits a little below the middle of the screen
                let target = window.innerHeight * .6 - journey.getBoundingClientRect().top;
                let i = 0;
                while (i < samples.length - 1 && samples[i].p.y < target)
                    i++;
                let at = target <= samples[0].p.y ? 0 : samples[i].l;

                // Near the very bottom of the page the tip may never reach the line, so finish the road
                if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2)
                    at = length;

                progress.style.strokeDashoffset = length - at;

                let point = progress.getPointAtLength(at);
                let ahead = progress.getPointAtLength(Math.min(length, at + 8));
                van.style.transform = 'translate(' + point.x + 'px, ' + point.y + 'px)';
                if (Math.abs(ahead.x - point.x) > 2)
                    van.classList.toggle('is-left', ahead.x < point.x);
                // The van stays parked at the finish, covering the join between the road and the badge
                van.style.opacity = at > 0 ? 1 : 0;

                let tipY = point.y + 1;
                $steps.each(function (n) {
                    this.classList.toggle('is-reached', at > 0 && tipY >= stopYs[n]);
                });
                journey.classList.toggle('is-finished', at >= length - 1);
            };

            let ticking = false;
            $(window).on('scroll', function () {
                if (ticking)
                    return;
                ticking = true;
                window.requestAnimationFrame(function () {
                    update();
                    ticking = false;
                });
            });

            if ('ResizeObserver' in window)
                new ResizeObserver(draw).observe(journey);
            else
                $(window).on('resize', draw);

            $(window).on('load', draw);
            draw();
        });
    };

    // Promo codes on offer tickets: tap to copy, the button says "Copied" for a moment
    module.initCopyCode = function () {
        $(document).on('click', '[data-copy-code]', function (e) {
            e.preventDefault();
            let $button = $(this);
            let code = String($button.data('copy-code'));

            let done = function () {
                let $label = $button.find('[data-copy-label] span');
                $button.addClass('is-copied');
                $label.text('Copied');
                clearTimeout($button.data('copy-timer'));
                $button.data('copy-timer', setTimeout(function () {
                    $button.removeClass('is-copied');
                    $label.text('Copy');
                }, 2000));
            };

            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(code).then(done);
                return;
            }

            // http:// (local dev) has no clipboard API
            let $field = $('<textarea readonly>').val(code).css({position: 'fixed', opacity: 0}).appendTo('body');
            $field[0].select();
            try {
                document.execCommand('copy');
                done();
            } catch (err) {}
            $field.remove();
        });
    };

    return module;
};
